module.exports = __webpack_public_path__ + "static/BellMechanism-d44f5c03eb859600499a57bf1b270bd1.jpg";